import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "babel-polyfill";
import { Set } from "immutable";
import 'lazysizes';
import 'lazysizes/plugins/print/ls.print';
import 'picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import * as React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "url-search-params-polyfill";
import "whatwg-fetch";
import { async } from "widgets-for-react";
import { CollectionRoutes } from "../../../Shared/components/Collection/CollectionRoutes";
import { initialCollectionApplicationState } from "../../../Shared/components/Collection/CollectionState";
import { EventRoutes } from "../../../Shared/components/Events/EventRoutes";
import { initialEventsApplicationState } from "../../../Shared/components/Events/EventState";
import { initialGoogleTranslateState } from "../../../Shared/components/GoogleTranslate/GoogleTranslate";
import { GoogleTranslateEngine } from "../../../Shared/components/GoogleTranslate/GoogleTranslateWidget";
import { initialLocalizationState } from "../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationState";
import { PREF_BRANCH_COOKIE } from "../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationUtils";
import { features, setFeatures } from "../../../Shared/features";
import { createDialogToggler } from "../../../Shared/pollyfill/HTMLDialogElement";
import { getCookie } from "../../../Shared/utils/cookies";
import { getCookieStatus } from "../../../Shared/utils/datalayer.mapping";
import { history } from "../../../Shared/utils/history";
import { getRegions } from "../../custom_api/api";
import { SearchModal } from "../search/searchModal";
import { searchModalId } from "../search/searchModal/searchModalLayout";
import { initialState as initialSearchPageState, searchResultsRoute } from "../search/searchPage/searchPageState";
import { newLoadingQuery, SearchPageWidget } from "../search/searchPage/searchPageWidget";
import { FramedCookiebar } from "./cookiebar/cookiebarState";
import { getCurrentFilterParams, setFilterParam } from "./filters";
import { Footer } from "./footer";
import { Header } from "./header";
import { Main } from "./library/main";
import { trackActivitySelection } from "./library/tracking";
import { managementApi } from "./management/ManagementApi";
import { ManagementRoutes } from "./management/ManagementRoutes";
import { initialManagementState } from "./management/ManagementState";
import { PageRenderer } from "./page_renderer";
history.listen(()=>{
    const links = document.getElementsByTagName("link");
    for(var i = 0; i < links.length; i++){
        const l = links[i];
        if (l.getAttribute("rel") == 'canonical') l.setAttribute('href', location.href);
    }
    const metas = document.getElementsByTagName('meta');
    for(var i = 0; i < metas.length; i++){
        const m = metas[i];
        if (m.getAttribute('property') == 'og:url') m.setAttribute('content', location.href);
    }
});
const applicationStateZero = {
    routes: Set([
        "/",
        "/nieuwsbrief"
    ]),
    regions: "loading",
    cookieBarVisible: getCookieStatus() === 'not_touched',
    showArchive: false,
    searchPageState: initialSearchPageState,
    managementState: initialManagementState(managementApi()),
    localizationState: initialLocalizationState,
    ...initialCollectionApplicationState(),
    ...initialEventsApplicationState,
    ...initialGoogleTranslateState
};
export const drupalHomepagePath = '/home';
class Application extends React.Component {
    componentDidMount() {
        const s = this.state;
        if (history.action == 'POP') history.action = 'REPLACE';
        if (s.regions == "loading") {
            getRegions().then((r)=>this.setState((s, _)=>({
                        ...s,
                        regions: r
                    })));
        }
    }
    selectRegion(e, history) {
        e.stopPropagation();
        setFilterParam('waar', e.target.value, history);
        trackActivitySelection("where", e.target.value);
    }
    selectPeriod(date, history) {
        setFilterParam('wanneer', date, history);
    }
    resetPeriod(history) {
        setFilterParam('wanneer', 'komend halfjaar', history);
    }
    selectLocation(selectedLocationId) {
        this.setState((s0)=>({
                ...s0,
                localizationState: {
                    ...s0.localizationState,
                    selectedLocationId: selectedLocationId
                }
            }));
    }
    render() {
        const regions = this.state.regions;
        const branchLocations = this.state.localizationState.branchLocations.kind == 'loaded' ? this.state.localizationState.branchLocations.value : [];
        const pageRenderer = (slug, history, params)=>{
            let filterParams = getCurrentFilterParams(true, params);
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    async()(this.state.localizationState.branchLocations).run((u)=>this.setState((s0)=>({
                                ...s0,
                                localizationState: {
                                    ...s0.localizationState,
                                    branchLocations: u(s0.localizationState.branchLocations)
                                }
                            }))),
                    /*#__PURE__*/ _jsx(PageRenderer, {
                        route: slug,
                        params: params,
                        regions: regions,
                        selectedPeriod: filterParams.has('wanneer') ? filterParams.get('wanneer') : 'komend-halfjaar',
                        selectedRegion: filterParams.has('waar') ? filterParams.get('waar') : '',
                        selectedCluster: filterParams.has('categorie') ? filterParams.get('categorie') : '',
                        selectPeriod: (dateOrPeriod)=>this.selectPeriod(dateOrPeriod, history),
                        selectRegion: (e)=>this.selectRegion(e, history),
                        selectCluster: (clusterSlug)=>setFilterParam('categorie', clusterSlug, history),
                        resetPeriod: ()=>this.resetPeriod(history),
                        toggleArchive: (cb)=>this.setState((s)=>({
                                    ...s,
                                    showArchive: !s.showArchive
                                }), ()=>cb ? cb() : null),
                        showArchive: this.state.showArchive,
                        localizationProps: {
                            selectedLocationId: this.state.localizationState.selectedLocationId,
                            branchLocations: branchLocations,
                            selectLocation: this.selectLocation
                        }
                    })
                ]
            });
        };
        const branchId = getCookie(PREF_BRANCH_COOKIE);
        const homePath = branchId && branchId != "0" ? `/node/${branchId}` : drupalHomepagePath;
        const handleToggleSearchModal = createDialogToggler(searchModalId);
        return /*#__PURE__*/ _jsx(HelmetProvider, {
            children: /*#__PURE__*/ _jsxs(BrowserRouter, {
                children: [
                    /*#__PURE__*/ _jsx(FramedCookiebar, {
                        visible: this.state.cookieBarVisible,
                        showCookiebar: (visible)=>this.setState((s)=>({
                                    ...s,
                                    cookieBarVisible: visible
                                }))
                    }),
                    /*#__PURE__*/ _jsx(GoogleTranslateEngine, {
                        state: this.state,
                        setState: this.setState.bind(this)
                    }),
                    /*#__PURE__*/ _jsx(Header, {
                        dropdown: this.state.googleTranslate.dropdown,
                        toggleSearchModal: handleToggleSearchModal
                    }),
                    /*#__PURE__*/ _jsx(SearchModal, {
                        toggleSearchModal: handleToggleSearchModal,
                        setSearchPageState: (newState, cb)=>this.setState((s)=>({
                                    ...s,
                                    searchPageState: {
                                        ...s.searchPageState,
                                        ...newState
                                    }
                                }), cb),
                        runNewQuery: (searchQuery)=>{
                            this.setState((s0)=>({
                                    ...s0,
                                    searchPageState: newLoadingQuery(searchQuery, s0.searchPageState)
                                }));
                        }
                    }),
                    /*#__PURE__*/ _jsx(Main, {
                        children: /*#__PURE__*/ _jsxs(Switch, {
                            children: [
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/",
                                    render: (props)=>pageRenderer(homePath, props.history)
                                }, "home"),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: searchResultsRoute,
                                    render: (_)=>SearchPageWidget({
                                            ...this.state.searchPageState
                                        }).run((searchPageState)=>this.setState((prevState)=>({
                                                    ...prevState,
                                                    searchPageState
                                                })))
                                }, "search"),
                                ManagementRoutes({
                                    state: this.state,
                                    setState: this.setState.bind(this)
                                }),
                                CollectionRoutes({
                                    state: this.state,
                                    setState: this.setState.bind(this),
                                    config: features().collection,
                                    localization: this.state.localizationState
                                }),
                                EventRoutes({
                                    state: this.state,
                                    setState: this.setState.bind(this),
                                    config: features().events,
                                    eventsOverviewClassNames: {
                                        timelineButton: "button button--tertiary quicklink__link",
                                        jumboSize: "small"
                                    },
                                    pageRenderer
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    exact: true,
                                    path: "/:slug*",
                                    render: (props)=>pageRenderer(props.location.pathname, props.history, props.location.search)
                                }, "page")
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Footer, {
                        showCookiebar: (visible)=>this.setState((s)=>({
                                    ...s,
                                    cookieBarVisible: visible
                                }))
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.state = applicationStateZero;
        this.selectRegion = this.selectRegion.bind(this);
        this.selectPeriod = this.selectPeriod.bind(this);
        this.resetPeriod = this.resetPeriod.bind(this);
        this.selectLocation = this.selectLocation.bind(this);
    }
}
export const render = ()=>{
    setFeatures(window.library);
    const container = document.getElementById("react-content");
    if (container) {
        const root = createRoot(container);
        root.render(/*#__PURE__*/ _jsx(Application, {}));
        removeLoader();
    }
};
function removeLoader() {
    const loader = document.documentElement.querySelector('#js--loader');
    if (loader == null) return;
    loader.remove();
}
{}render();
